import { Reveal } from "./Reveal";
import { AlertTriangle, ArrowRight } from "lucide-react";

const TIPS = [
  "Verify the employer before proceeding",
  "Never rely solely on WhatsApp offers",
  "Check employment contracts carefully",
  "Verify recruitment agencies",
  "Confirm work-permit documentation",
  "Beware of unrealistic salaries",
  "Never pay unidentified third parties",
];

export const Safety = () => (
  <section
    id="safety"
    data-testid="safety-section"
    className="py-24 md:py-32 px-6 md:px-12 bg-[#f5f5f4] border-y border-[#e4e4e7]"
  >
    <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <AlertTriangle size={24} className="text-[#ff3b30]" />
          <span className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30]">
            Candidate safety
          </span>
        </div>
        <h2 className="font-head uppercase tracking-tighter leading-[0.92] text-4xl md:text-6xl mb-8">
          Protecting candidates from recruitment fraud.
        </h2>
        <p className="font-body text-[#52525b] leading-relaxed max-w-md text-lg mb-10">
          If an opportunity feels wrong, pause and verify. We help candidates confirm whether a
          job, employer or agency is genuine — free of charge.
        </p>
        <a
          href="/due-diligence"
          data-testid="safety-cta"
          className="group inline-flex items-center gap-3 bg-[#0a0a0a] hover:bg-[#ff3b30] text-white font-head uppercase text-sm tracking-wide px-8 py-4 w-max transition-colors duration-300"
        >
          Verify a recruitment opportunity
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
        </a>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="border-t border-[#e4e4e7]">
          {TIPS.map((t, i) => (
            <div
              key={t}
              data-testid={`safety-tip-${i}`}
              className="flex items-start gap-4 py-5 border-b border-[#e4e4e7]"
            >
              <span className="font-head text-xl text-[#ff3b30] shrink-0">✕</span>
              <span className="font-body text-lg text-[#0a0a0a]">{t}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
